import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=9413945a&scoped=true&"
import script from "./Recipient.vue?vue&type=script&lang=js&"
export * from "./Recipient.vue?vue&type=script&lang=js&"
import style0 from "./Recipient.vue?vue&type=style&index=0&id=9413945a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9413945a",
  null
  
)

export default component.exports